export const SET_EMAIL_ADDRESS = 'SET_EMAIL_ADDRESS'
export const SET_REGISTRATION_VALIDATION_ERRORS = 'SET_REGISTRATION_VALIDATION_ERRORS'
export const SET_REGISTRATION_VALIDATION_SUCCESS = 'SET_REGISTRATION_VALIDATION_SUCCESS'
export const RESET = 'RESET'

export default {
  SET_EMAIL_ADDRESS,
  SET_REGISTRATION_VALIDATION_ERRORS,
  SET_REGISTRATION_VALIDATION_SUCCESS,
  RESET
}



// WEBPACK FOOTER //
// ./src/store/modules/registration/mutation-types.js